import { useParams } from "react-router-dom";

import { ClientTeamCard } from "../../../../../clientTeam/ClientTeamCard";
import { ContactEmailsWidget } from "./widgets/contact-emails/ContactEmailsWidget";
import { ContactFilesWidget } from "./widgets/contact-files/ContactFilesWidget";
import { ContactInfo } from "./widgets/contact-info/ContactInfo";
import { ContactInvoicesWidget } from "./widgets/contact-invoices/ContactInvoicesWidget";
import { ContactLinkedProfilesWidget } from "./widgets/contact-linked-profiles/ContactLinkedProfilesWidget";
import { ContactNotesWidget } from "./widgets/contact-notes/ContactNotesWidget";
import { ContactTagsWidget } from "./widgets/contact-tags/ContactTagsWidget";
import { ContactWorksWidget } from "./widgets/contact-works/ContactWorksWidget";

/**
 * Individual's profile. Roadmap 1880 (owner 2026-10-22): the Client portal has
 * its own client tab, and Tags is a widget like the others, so the two wide
 * columns hold six even widgets: Work · Notes / Files · Emails / Invoices ·
 * Tags (each 386 px high).
 */
export const ContactProfile = () => {
  const { customerId } = useParams();
  return (
    <div
      className={
        "grid grid-cols-[minmax(0,2fr)_minmax(0,3fr)_minmax(0,3fr)] gap-5 font-Manrope max-md:grid-cols-1"
      }>
      <div className={"flex h-fit min-w-0 flex-col gap-5"}>
        <ContactInfo />
        <ClientTeamCard customerId={customerId} />
        <ContactLinkedProfilesWidget />
      </div>
      <div className={"flex h-fit min-w-0 flex-col gap-5"}>
        <ContactWorksWidget />
        <ContactFilesWidget />
        <ContactInvoicesWidget />
      </div>
      <div className={"flex h-fit min-w-0 flex-col gap-5"}>
        <ContactNotesWidget />
        <ContactEmailsWidget />
        <ContactTagsWidget />
      </div>
    </div>
  );
};
